import { render, staticRenderFns } from "./international.vue?vue&type=template&id=0d89fcf8&scoped=true&"
import script from "./international.vue?vue&type=script&lang=js&"
export * from "./international.vue?vue&type=script&lang=js&"
import style0 from "./international.vue?vue&type=style&index=0&id=0d89fcf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d89fcf8",
  null
  
)

export default component.exports